var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "1%" }, attrs: { align: "left" } },
    [
      _c("v-divider"),
      _c(
        "v-flex",
        [
          _c(
            "div",
            { staticStyle: { "font-size": "22px", "margin-top": "1%" } },
            [_vm._v("Proveedores")]
          ),
          _c(
            "v-card",
            { staticStyle: { "margin-top": "1%" } },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-material estilo-grilla",
                attrs: { "grid-options": _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }